import React, { useEffect } from 'react';
import { useRoutes } from 'react-router-dom';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import routes from 'routes';
import { Provider } from 'react-redux';
import store from './store/store';
import { CssBaseline } from '@mui/material';
import { ColorModeContext, useMode } from 'theme';
import Radar from 'radar-sdk-js';
import { FSConfig } from 'freightsmart-config';
// import { StripeProvider } from 'react-stripe-elements';
/**
 * Redux Store which dispatch
 */

const App = () => {
  const routing = useRoutes(routes);
  const [theme, colorMode] = useMode();
  Radar.initialize(FSConfig.radarGeoAPI);
  
  return (
    <Provider store={store}>
      {/* <StripeProvider apiKey="pk_test_fHowK7rQzFRuVtYALo5IuG8700jxkIyhEb"> */}
      <StyledEngineProvider injectFirst>
        <ColorModeContext.Provider value={colorMode}>
          <ThemeProvider theme={theme}>        
            <CssBaseline />
            {routing}
          </ThemeProvider>
        </ColorModeContext.Provider>
      </StyledEngineProvider>
      {/* </StripeProvider> */}
    </Provider>
  );
};

export default App;